import { I18nText as I18n, i18nKeys } from '@gloat/glocalize';

const useUserHighlightBadgesConstants = () => {
  return {
    LOCREG: {
      getLabel: () => (
        <span>
          <I18n id={i18nKeys.HIRE_CANDIDATE_BADGES_LOCREG} />
        </span>
      ),
      getEditableLabel: () => (
        <span>
          <I18n id={i18nKeys.PROFILE_BADGES_LOCAREG} />
        </span>
      ),
    },

    CROSSF: {
      getLabel: () => (
        <span>
          <I18n id={i18nKeys.HIRE_CANDIDATE_BADGES_CROSSF} />
        </span>
      ),
      getEditableLabel: () => (
        <span>
          <I18n id={i18nKeys.PROFILE_BADGES_CROSSF} />
        </span>
      ),
    },

    CROSSD: {
      getLabel: () => <I18n id={i18nKeys.HIRE_CANDIDATE_BADGES_CROSSD} />,
      getEditableLabel: () => <I18n id={i18nKeys.PROFILE_BADGES_CROSSD} />,
    },
    INTER: {
      getLabel: () => <I18n id={i18nKeys.HIRE_CANDIDATE_BADGES_INTER} />,
      getEditableLabel: () => <I18n id={i18nKeys.PROFILE_BADGES_INTER} />,
    },
  };
};

export default useUserHighlightBadgesConstants;
